import { Stripe, PaymentSheetEventsEnum } from '@capacitor-community/stripe';
import { Capacitor } from '@capacitor/core';

const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

/**
 * Initialize the native Stripe SDK for Capacitor
 * Only runs on native platforms (iOS/Android)
 */
export const initializeStripeNative = async (): Promise<void> => {
  if (!Capacitor.isNativePlatform()) return;
  
  try {
    await Stripe.initialize({
      publishableKey: STRIPE_PUBLISHABLE_KEY,
    });
    console.log('Native Stripe SDK initialized');
  } catch (error) {
    console.error('Failed to initialize native Stripe:', error);
  }
};

/**
 * Present the native Stripe PaymentSheet
 * This shows Google Pay on Android and Apple Pay on iOS natively
 */
export const presentPaymentSheet = async (clientSecret: string): Promise<{
  success: boolean;
  error?: string;
}> => {
  try {
    await Stripe.createPaymentSheet({
      paymentIntentClientSecret: clientSecret,
      merchantDisplayName: 'imata',
      enableGooglePay: true,
      enableApplePay: true,
      GooglePayIsTesting: false,
      countryCode: 'GB',
      currencyCode: 'GBP',
    });

    const result = await Stripe.presentPaymentSheet();
    
    if (result.paymentResult === PaymentSheetEventsEnum.Completed) {
      return { success: true };
    } else if (result.paymentResult === PaymentSheetEventsEnum.Canceled) {
      return { success: false, error: 'Payment cancelled' };
    } else {
      return { success: false, error: 'Payment failed' };
    }
  } catch (error: any) {
    console.error('Native payment error:', error);
    return { success: false, error: error.message || 'Payment failed' };
  }
};

/**
 * Check if native payment is available (running on iOS/Android)
 */
export const isNativePaymentAvailable = (): boolean => {
  return Capacitor.isNativePlatform();
};
